/*
 * Shared allowlist-based validation for externally supplied URLs.
 *
 * The component-details API supplies script, iframe and widget endpoint URLs
 * (wca.scriptSrc, bob.scriptSrc, bob.iframeSrc, bob.baseUrl, targetUrl, etc.).
 * These values are treated as untrusted input: before a URL is assigned to a
 * script/iframe element or forwarded to a private authentication widget it must
 * resolve to the application's own origin or to an explicitly approved Wells
 * Fargo host over HTTPS. Anything else is rejected.
 */
const TRUSTED_HOST_SUFFIXES = [
	'.wellsfargo.com',
	'.wellsfargo.net',
	'.accesswca.com',
	'.getmyaccounts.com',
	'.onlinemyaccounts.com',
	'.wellsfargomedia.com',
]

function parseUrl(url) {
	if (!url || typeof url !== 'string') {
		return null
	}
	try {
		return new URL(url, window.location.origin)
	} catch (error) {
		return null
	}
}

export function isTrustedResourceUrl(url) {
	const parsed = parseUrl(url)
	if (!parsed) {
		return false
	}
	if (parsed.origin === window.location.origin) {
		return true
	}
	if (parsed.protocol !== 'https:') {
		return false
	}
	const hostname = parsed.hostname.toLowerCase()
	return TRUSTED_HOST_SUFFIXES.some(
		(suffix) => hostname === suffix.slice(1) || hostname.endsWith(suffix),
	)
}

export function getTrustedBaseUrl(url) {
	const parsed = parseUrl(url)
	if (!parsed || !isTrustedResourceUrl(url)) {
		return ''
	}
	return parsed.origin
}
